import { render, staticRenderFns } from "./transfers.vue?vue&type=template&id=f83cb27a&scoped=true&"
import script from "./transfers.vue?vue&type=script&lang=ts&"
export * from "./transfers.vue?vue&type=script&lang=ts&"
import style1 from "./transfers.vue?vue&type=style&index=1&id=f83cb27a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83cb27a",
  null
  
)

export default component.exports